<i18n src="../../locales/lang.json"></i18n>

<template>
  <div style="position:absolute;top:0px;">
    <draggable v-bind="dragOptions" class="menu-container" filter=".ignore-elements" v-model="realValue" :move="checkMove" :group="{ name: 'description', pull: 'clone' }" tag="div" @start="dragStart" @end="dragEnd" :clone="cloneElement" @update="dragUpdated" v-bind:style="'background-color:green;min-height:40px;'">
      <div  v-for="(el, index) in realValue" v-bind:class="getClass(el,index, realValue.length)" v-bind:style="getPosition(el, index, orientation, direction, realValue.length)">
        <a  href="#" data-popup="popover" v-bind:data-index="index" data-trigger="hover" data-delay="600" data-animation="false" data-placement="left" v-bind:data-original-title="el.tooltip" class="menu-link" v-bind:class="{'open-right':el.expanded == true && (el.direction == 'right' || el.direction == null || el.direction == 'downright'),'open-left':el.expanded == true && (el.direction == 'left' || el.direction == 'downleft'),'skin primary-button' : isroot == true}" v-bind:style="getLinkStyle(el, index, orientation, direction, realValue.length)" v-hammer:tap="() => doClick(el)">
          <i class="icon" v-bind:class="el.iconclass" v-bind:style="getTextStyle(el)"></i>
        </a>
        <span v-show="el.label">{{el.label}}</span>
        <nested-draggable-menu v-bind:isroot="false" class="submenu open" v-bind:level="level + 1" v-bind:parentexpanded="el.expanded" v-bind:test="'submenu' + _uid + '_' + index" v-bind:key="'submenu' + _uid + '_' + index" :ref="'submenu' + _uid + '_' + index" v-bind:orientation="el.orientation" v-bind:direction="el.direction" v-model="el.elements" @clickItem="clickItem" />
      </div>
    </draggable>
      
  </div>
</template>

<script>

  import { TimelineLite } from 'gsap'
  import { gsap } from 'gsap';
  import draggable from "vuedraggable";
  var dragging = false;

  export default {
    name: "nested-draggable-menu",
    data() {
      return {
        elements: [],
        dragging: false,
        idGlobal: 0,
        dragging
      }
    }
    ,
    components: {
      TimelineLite,
      gsap,
      draggable
    },
    methods: {

      getPosition(el, index, orientation, direction, itemcount) {
        var startX = 0;
        var startY = 0;

        var str = ''

        if (direction == "spreadleft") {
          if (orientation == "horizontal") {
            startX = -60;
            if (itemcount > 1)
              startY = 30;
            startY = startY - ((itemcount) * 60 / 2)
            startY = + startY + (index * 60);
          }
        }
        else if (direction == "spreadright") {
          if (orientation == "horizontal") {
            startX = 60;
            if (itemcount > 1)
              startY = 30;
            startY = startY - ((itemcount) * 60 / 2)
            startY = + startY + (index * 60);
          }
        }
        else if (direction == "spreadbottom") {
          if (orientation == "horizontal") {
            startY = 60;
            if (itemcount > 1)
              startX = 30;
            startX = startX - ((itemcount) * 60 / 2)
            startX = + startX + (index * 60);
          }

          //https://stackoverflow.com/questions/25361011/placing-dots-in-an-arc
        }
        else if (direction == "spreadbottom") {
          if (orientation == "horizontal") {
            startY = 60;
            if (itemcount > 1)
              startX = 30;
            startX = startX - ((itemcount) * 60 / 2)
            startX = + startX + (index * 60);
          }
        }
        else if (direction == "downright") {
          if (orientation == "horizontal") {
            //startX = ((itemcount + 1) * 60)
            startX = 60;
            startX = startX + (index * 60);
            startY = 0
          }
          else { //vertical
            //startX = 0
            //startY = ((itemcount + 1) * 60)
            //startY = startY + (index * 60);
            startX = 0
            startY = ((index + 1) * 60);
          }
        }
        else if (direction == "downleft") {
          if (orientation == "horizontal") {
            startX = -((itemcount) * 60)
            startX = startX + (index * 60);
            startY = 0
          }
          else { //vertical
            //startX = 0
            //startY = ((itemcount + 1) * 60)
            //startY = startY + (index * 60);

            startX = 0
            startY = ((index + 1) * 60);
          }
        }

        str += ';margin-left:' + startX + 'px';
        str += ';margin-top:' + startY + 'px';

        return str;
      },
      getLinkStyle(el, index, orientation, direction, itemcount) {
        var str = 'color:inherit'
        if (el.bgColor)
          str += ';background-color:' + el.bgColor;
        return str;
      },
      getTextStyle(el) {
        var str = ''
        if (el.color)
          str += ';color:' + el.color;
        return str;
      },
      refresh() {
        Vue.set(this, "value", this.value);
        Vue.set(this, "list", this.list);
        this.$forceUpdate();
      },
      update() {
        this.$forceUpdate();
      },

      refreshParent() {
        this.$forceUpdate();
        this.$parent.refreshParent();
      },
      setData(data) {
        this.value = data;
        this.refresh();
      },
      collapse() {

      },
      toggleExpand(el) {
        if (el.static == true)
          return;

        if (!el.elements || el.elements.length == 0) {
          return;
        }

        if (el.expanded == true)
          el.expanded = false;
        else
          el.expanded = true;

        if (el.elements != null) {
         
          for (var i = 0; i < el.elements.length; i++) {
            el.elements[i].parentexpanded = el.expanded;
          }
        }
        
        this.refresh();
      },

      expand(el) {
        el.expanded = true;
        this.refresh();
      },
     
      clickItem(el) {
        this.$emit('clickItem', el);
      },
      getClass(el, index, length) {
        var ret = "";
        if (this.parentexpanded != true) {
          ret = "item";
        }
        else {
          ret = "item show";
        }
        return ret;
      },
      addElementByClick() {

      }
      ,
      doClick(element, e) {

        
        if (this.level == 0) {
          this.doMainClick(null);
          return;
        }

        if (element.elements && element.elements.length > 0) {
          this.toggleExpand(element)
          return;
        }
          

        //e.stopPropagation();
        this.idGlobal = this.idGlobal - 1;

        var newText = "";
        if (typeof (element.text) != "undefined" && element.text != null)
          newText = element.text;
        var copy = {
          Id: this.idGlobal--,
          TaskId: -1,
          Name: 'Add a name',
          Text: newText,
          ElementType: element.elementType,
          Settings: element.settings,
          OverRidable: element.overRidable,
          Elements: element.childElements,
          UserInputs:[],
          Url: "",
          IsChanged: true,
          ParentId: null
        }

        for (var i = 0; i < copy.Elements.length; i++) {
          copy.Elements[i].Id = this.idGlobal--;
        }

        copy.Id = this.idGlobal;
        vm.$root.$emit('procedure_add_element', copy);
      },
      doMainClick(e) {
        if(e != null)
          e.preventDefault();
        vm.$root.$emit('check_if_procedure_editor_is_closable');

      },
      getSettings() {
        return { name: 'people', pull: 'clone', put: false }
      },

      onDragMove: function onDragMove(evt) {

        return onMove(evt);
      },
      handleChange() {
        //alert('changed');
      },
      inputChanged(value) {
        this.activeNames = value;
      },

      getComponentData() {
        return {
          on: {
            change: this.handleChange,
            input: this.inputChanged
          },
          attrs: {
            wrap: true,
            test: 'olle'
          },
          props: {
            value: this.activeNames,
            value2: 'bertil'
          },
          test: "testing"
        };
      },
      checkMove: function (evt, someother) {
        if (this.dragging == false)
          hideAllToolTips();
        this.dragging = true;
        return true;
      },
      move() {
        return false;
      },
      handleChange(event) {
        return false;
      },
      inputChanged(event) {
      },
      log: function (evt) {
        //window.console.log(evt);
      },
      cloneElement(
        { elementType, overRidable, settings, text, childElements }) {
        var newText = "";
        if (typeof (text) != "undefined" && text != null)
          newText = text;


        var copy = {
          Id: this.idGlobal--,
          TaskId: -1,
          Name: 'Add a name',
          Text: newText,
          ElementType: elementType,
          Settings: settings,
          OverRidable: overRidable,
          Elements: childElements,
          Url: "",
          IsChanged: true,
          ParentId: null,
          UserInputs: []
        };

        for (var i = 0; i < copy.Elements.length; i++) {
          copy.Elements[i].Id = this.idGlobal--;
        }

        return copy;
      },
      dragStart(event) {

      },

      dragEnd(event) {
        this.dragging = false;
      },
      dragUpdated(event) {
        //this.$root.$emit('stoppedDragging');
        return false;
      },
      dragCloned(event) {
      },
      dragSorted(event) {

      },
      dragMoved(event) {

      },
      dragAdded(event) {

      },

      addItem(event) {
      }
    },
    computed: {
      realValue() {
        return this.value != null ? this.value : this.list;
      },
      
    },
    props: {
      value: {
        required: false,
        type: Array,
        default() {
          return null
        }
      },
      list: {
        required: false,
        type: Array,
        default() {
          return null
        }
      },
      isroot: {
        required: false,
        type: Boolean,
        default: false
      },
      orientation: {
        required: false,
        type: String,
        default: "vertical"
      },
      level: {
        required: false,
        type: Number,
        default: 0
      },
      parentexpanded: {
        required: false,
        type: Boolean,
        default: false
      },
      direction: {
        required: false,
        type: String,
        default: "right"
      },
      
    },
    mounted() {

      

    },
    watch: {
      value: function (newVal, oldVal) {
        
      },
      list: function (newVal, oldVal) {
        
      },
      
    },
  };
</script>

<style>
  
</style>

<style scoped>

  .icon {
    padding: 14px !important;
    font-size: 20px !important;
    color: rgb(51, 51, 51);
  }

  .icon-2x {
    font-size: 27px !important;
    padding: 11px !important;
    margin-left: -1px;
  }

  .menu-link {
    position: absolute;
    border-radius: 50%;
    -webkit-transition: -webkit-transform .4s ease-in-out;
    -ms-transition: -ms-transform .4s ease-in-out;
    transition: transform .4s ease-in-out;
    line-height: initial;
    box-shadow: 0 3px 6px rgba(0,0,0,.16),0 3px 6px rgba(0,0,0,.23);
    background-color: rgb(240, 242, 245);
  }

  .menu-link, .menu-link:active, .menu-link:focus {
    outline: none;
    -moz-outline-style: none;
  }

    .menu-link.open-right {
      transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      -webkit-transform: rotate(45deg);
    }

    .menu-link.open-left {
      transform: rotate(-45deg);
      -ms-transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
    }

    .menu-link.open-left {
      transform: rotate(-45deg);
      -ms-transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
    }

  .submenu .item {
    

    /*transition here*/
  }

  .item {
    top: 0;
    left: 0;
    opacity: 1;
    margin-left: 0;
    /*transition: top 2s ease-in-out, margin-left 2s ease-in-out;*/
    transition: all 0.5s ease-in-out;
  }

  .menu-link:hover::after {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255,255,255,0.2);
    border-radius: 50%;
  }

  .open .item {
    position: absolute;
    visibility: hidden;
    opacity: 0;
    top: 0;
    margin-left: 0;
  }

  .item.show {
    visibility: visible;
    opacity: 1;
  }



   


  .menu-container {
    position: absolute;
    top: 0px;
  }


</style>




// WEBPACK FOOTER //
// src/components/menues/nested-draggable-menu.vue